<template>
  <v-container class="accent_dark">
    <v-snackbar v-model="snackbar.model" :color="snackbar.color" top>
      <b>{{ snackbar.text }}</b>
      <v-btn text @click="snackbar.model = false">Aceptar</v-btn>
    </v-snackbar>
    <v-row class="py-12">
      <v-col cols="12" sm="12" md="8" lg="6" offset-lg="1">
        <h2
          v-html="title"
          :class="[$vuetify.breakpoint.mdAndUp ? '' : 'mt-5']"
          class="display-1 font-weight-bold black--text mb-8 customFont"
        ></h2>
        <v-form>
          <v-text-field
            solo
            v-model="name"
            label="Nombre completo"
            required
          ></v-text-field>
          <v-text-field
            solo
            v-model="tel"
            label="Telefono"
            required
          ></v-text-field>
          <v-text-field
            solo
            v-model="email"
            label="Correo"
            required
          ></v-text-field>
          <v-select
            solo
            :items="items"
            label="Sucursal"
            v-model="sucursal"
            dense
            outlined
          ></v-select>
          <v-textarea solo label="Comentario" v-model="coment"></v-textarea>
          <v-row>
            <v-col cols="12" sm="6">
              <v-btn
                x-large
                block
                class="primary_dark white--text"
                @click="send()"
                :loading="isLoading"
                >Enviar</v-btn
              >
            </v-col>
            <v-col cols="12" sm="6">
              <v-btn
                x-large
                block
                color="white"
                class="primary_dark--text"
                @click="clean()"
                :loading="isLoading"
                >Borrar</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="4">
        <v-img
          width="100%"
          :height="$vuetify.breakpoint.mdAndUp ? '100%' : '40vh'"
          cover
          :src="image"
        ></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.bg-accent-dark {
  background-color: #f9a61b !important;
}
.customFont {
  font-family: "Eras Medium ITC" !important;
}
.boldFont {
  font-weight: bolder !important;
}
</style>
<script>
import axios from "axios";
export default {
  props: ["image", "title", "text", "imgleft"],
  data() {
    return {
      isLoading: false,
      sucursal: "",
      name: "",
      tel: "",
      email: "",
      coment: "",
      items: ["Tepic", "Puerto Vallarta"],
      snackbar: {
        model: false,
        color: "green",
        text: "",
      },
    };
  },
  methods: {
    send() {
      if (
        this.name == "" ||
        this.tel == "" ||
        this.email == "" ||
        this.coment == ""
      ) {
        this.snackbar.text = "Complete los campos";
        this.snackbar.model = true;
        this.snackbar.color = "red";
        return;
      }
      this.isLoading = true;
      let self = this;
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("phone", this.tel);
      formData.append("email", this.email);
      formData.append("sucursal", this.sucursal);
      formData.append("comment", this.coment);
      axios({
        method: "post",
        url: "https://www.software.tidingo.com/api/send-capitalica-contact",
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        },
      })
        .then(function(response) {
          self.isLoading = false;
          if (response.data.status == 200) {
            self.clean();
            self.snackbar.text = "Correo enviado exitosamente";
            self.snackbar.model = true;
            self.snackbar.color = "green";
          } else {
            self.snackbar.text = "Correo no enviado, intente nuevamente";
            self.snackbar.model = true;
            self.snackbar.color = "red";
          }
        })
        .catch(function() {
          self.isLoading = false;
        });
    },
    clean() {
      this.name = "";
      this.tel = "";
      this.email = "";
      this.coment = "";
      this.sucursal = "";
    },
  },
};
</script>
